import { ITableRow } from '../../../../store/mst/Upload/models';
import { CustomValidatorArgs } from '../types/CSVTypes';
import { HeaderColumnKeyEnum } from '../types/columnHeader';
import { isLatitude, isLongitude } from '../../../../helpers/validateCoordinates';

export type LatLngRow = {
  latitude: string | undefined;
  longitude: string | undefined;
};

const hasBothPairs = (row: LatLngRow, columnKey: string | undefined) => {
  if (!row.latitude || !row.longitude) {
    if (columnKey === 'latitude' && !row.latitude) {
      return false;
    }
    if (columnKey === 'longitude' && !row.longitude) {
      return false;
    }
  }

  return true;
};

export const coordinateIsNullOrUndefined = (coordinateCell: any) => {
  return !coordinateCell || coordinateCell?.type === 'null';
};

export const getCoordinateCell = (type: HeaderColumnKeyEnum.LATITUDE | HeaderColumnKeyEnum.LONGITUDE, row?: ITableRow, locationHeaders?: any) => {
  const index = locationHeaders?.[type]?.matchedIndex;
  return row?.cells.find((col: any) => col.columnIdx === index);
};

export const latLngValidator = ({ value, dependsOn, columnKey }: CustomValidatorArgs) => {
  const latitude = columnKey === 'latitude' ? value : dependsOn;
  const longitude = columnKey === 'longitude' ? value : dependsOn;
  if (latitude || longitude) {
    if (!hasBothPairs({ latitude, longitude }, columnKey)) {
      return columnKey === 'latitude' ? 'missingLatitude' : 'missingLongitude';
    }
    if (columnKey === 'latitude' && !isLatitude(latitude)) {
      return 'notLatitude';
    }
    if (columnKey === 'longitude' && !isLongitude(longitude)) {
      return 'notLongitude';
    }
  }

  return null;
};
